const servicesActionTypes = {
  FETCH_SPECIALITIES: 'FETCH_SPECIALITIES',
  FETCH_SPECIALITIES_SUCCESS: 'FETCH_SPECIALITIES_SUCCESS',
  FETCH_SPECIALITIES_FAIL: 'FETCH_SPECIALITIES_FAIL',

  FETCH_SERVICES_LIST: 'FETCH_SERVICES_LIST',
  FETCH_SERVICES_LIST_SUCCESS: 'FETCH_SERVICES_LIST_SUCCESS',
  FETCH_SERVICES_LIST_FAIL: 'FETCH_SERVICES_LIST_FAIL',

  ADD_OR_EDIT_SERVICE: 'ADD_OR_EDIT_SERVICE',
  ADD_OR_EDIT_SERVICE_SUCCESS: 'ADD_OR_EDIT_SERVICE_SUCCESS',
  ADD_OR_EDIT_SERVICE_FAIL: 'ADD_OR_EDIT_SERVICE_FAIL',

  RESET_ADD_OR_EDIT_SERVICE: 'RESET_ADD_OR_EDIT_SERVICE',

  DELETE_SERVICE: 'DELETE_SERVICE',
  DELETE_SERVICE_SUCCESS: 'DELETE_SERVICE_SUCCESS',
  DELETE_SERVICE_FAIL: 'DELETE_SERVICE_FAIL',
};

export default servicesActionTypes;
